import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {PartnerDtoModel} from '../shared/models/partner.dto.model';
import {OffreService} from '../shared/services/offre.service';
import {OfferDtoModel, OfferHolderModel} from '../shared/models/offer.dto.model';
import {FileUpload} from 'primeng/fileupload';
import {ErrorStateMatcher} from '@angular/material/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {LocalizationService} from '../shared/services/localization.service';
import {LoaderService} from '../shared/services/loader.service';
import {FileService} from '../shared/services/file.service';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AuthentificationService} from '../login/services/authentification.service';

@Component({
    selector: 'njoy-offres',
    templateUrl: './offres.component.html',
    styleUrls: ['./offres.component.scss']
})
export class OffresComponent implements OnInit {

    public offers = [];

    public partner: PartnerDtoModel;

    public addNewOfferDialog = false;
    public modalTitle = '';
    public offerForm;
    @ViewChild('fileUpload')
    public fileUploader: FileUpload;
    public matcher = new ErrorStateMatcher();
    public uploadedFile;
    public noFileUploaded = false;
    public newOffer: OfferHolderModel;
    public selectedOffer: any;
    public isAddAction = true;

    public isAdmin = true;

    public updateRequestModal = false;

    @Input() set selectedPartner(value: PartnerDtoModel) {
        this.partner = value;
        if (this.partner.uuid) {
            this.getAllOffersByPartner();
        }

    }

    constructor(private offerService: OffreService,
                private loaderService: LoaderService,
                private formBuilder: UntypedFormBuilder,
                private localizationService: LocalizationService,
                private messageService: MessageService,
                private confirmationService: ConfirmationService,
                private authenService: AuthentificationService,
                private fileService: FileService) {
    }

    ngOnInit(): void {
        this.isAdmin = this.authenService.isAdmin();
        if (!this.authenService.isAdmin()) {
            this.getOffersByUserUuid();
        }
    }

    public addNew(): void {
        if (!this.partner.uuid) {
            this.displayMessage('error', 'PARTNER.VALIDATION_ERROR', 'PARTNER.SAVE_PARTNER_BEFORE');
        } else {
            this.uploadedFile = undefined;
            this.modalTitle = this.localizationService.translate('OFFERS.ADD_NEW_MODAL_TITLE');
            this.addNewOfferDialog = true;
            this.isAddAction = true;
            this.noFileUploaded = false;
            this.initEmtpyFormValue();
        }
    }

    private initEmtpyFormValue(offer?: OfferDtoModel): void {
        this.offerForm = this.formBuilder.group({
            label: [offer ? offer.label : '', [
                Validators.required
            ]],
            description: [offer ? offer.description : ''],
            initialPrice: [offer ? offer.initialPrice : 0, [Validators.min(1)]],
            buyingPrice: [offer ? offer.buyingPrice : 0, [Validators.min(1)]]
        });
    }

    get getControl() {
        return this.offerForm.controls;
    }


    public addOrUpdateOffer(): void {
        this.displayRequiredMessage();
        if (this.offerForm.status === 'VALID') {
            if (this.modalTitle === this.localizationService.translate('OFFERS.ADD_NEW_MODAL_TITLE')) {
                this.uploadFileAndAddNewOffer();
            } else {
                this.uploadFileAndUpdateOffer();
            }
        }
    }

    private uploadFileAndAddNewOffer() {
        if (!this.noFileUploaded) {
            this.loaderService.startLoading();
            this.fileService.uploadOfferFile(this.uploadedFile).subscribe(
                (path: string) => {
                    this.patchValuesForAdd();
                    this.addNewOffer(path);
                }, (err: any) => {
                    this.loaderService.stopLoading();
                    console.log(err)
                }
            );
        }
    }

    private uploadFileAndUpdateOffer() {
        if (this.uploadedFile) {
            this.loaderService.startLoading();
            this.fileService.uploadOfferFile(this.uploadedFile).subscribe(
                (path: string) => {
                    this.patchValuesForUpdate();
                    this.updateOffer(path);
                }, (err: any) => {
                    this.loaderService.stopLoading();
                    console.log(err)
                }
            );
        } else {
            this.patchValuesForUpdate();
            this.updateOffer(this.selectedOffer.imagePath);
        }
    }

    private patchValuesForAdd(): void {
        this.newOffer = new OfferHolderModel();
        this.newOffer.label = this.offerForm.value.label;
        this.newOffer.description = this.offerForm.value.description;
        this.newOffer.buyingPrice = this.offerForm.value.buyingPrice;
        this.newOffer.initialPrice = this.offerForm.value.initialPrice;
        this.newOffer.partnerUuid = this.partner.uuid;
    }

    private patchValuesForUpdate(): void {
        this.selectedOffer.label = this.offerForm.value.label;
        this.selectedOffer.description = this.offerForm.value.description;
        this.selectedOffer.buyingPrice = this.offerForm.value.buyingPrice;
        this.selectedOffer.initialPrice = this.offerForm.value.initialPrice;
    }

    private addNewOffer(imagePath?: string) {
        this.newOffer.imagePath = imagePath;
        this.offerService.persistOffer(this.newOffer).subscribe(
            () => {
                this.loaderService.stopLoading();
                this.displayMessage('success', 'CLIENT.SUCCESS_SUMMARY', 'OFFERS.ADD_SUCCESS_DETAIL');
                this.addNewOfferDialog = false;
                this.getAllOffersByPartner();
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    private updateOffer(imagePath?: string) {
        this.selectedOffer.imagePath = imagePath;
        this.offerService.updateOffer(this.selectedOffer).subscribe(
            () => {
                this.loaderService.stopLoading();
                this.displayMessage('success', 'CLIENT.SUCCESS_SUMMARY', 'OFFERS.UPDATE_SUCCESS_DETAIL');
                this.addNewOfferDialog = false;
                this.getAllOffersByPartner();
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    private getAllOffersByPartner(): void {
        this.loaderService.startLoading();
        this.offerService.getOffersByPartnerUuid(this.partner.uuid).subscribe(
            (data: OfferDtoModel[]) => {
                this.loaderService.stopLoading();
                this.offers = data;
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    private getOffersByUserUuid(): void {
        this.loaderService.startLoading();
        this.offerService.getOffersByConnectedUser().subscribe(
            (data: OfferDtoModel[]) => {
                this.loaderService.stopLoading();
                this.offers = data;
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    public onUpload(event) {
        this.noFileUploaded = false;
        this.uploadedFile = event.files[0];
    }

    public clearFile() {
        this.uploadedFile = undefined;
    }

    private displayRequiredMessage(): void {
        this.offerForm.touched = true;
        this.noFileUploaded = false;
        const keys = Object.keys(this.offerForm.controls);
        keys.forEach((element: any) => {
            this.offerForm.controls[element].touched = true;
        });
        if (!this.uploadedFile) {
            this.noFileUploaded = true;
        }
    }

    public openUpdateModal(offer: OfferDtoModel): void {
        this.uploadedFile = undefined;
        this.modalTitle = this.localizationService.translate('OFFERS.UPDATE_MODAL_TITLE');
        this.addNewOfferDialog = true;
        this.noFileUploaded = false;
        this.isAddAction = false;
        this.selectedOffer = {...offer};
        this.initEmtpyFormValue(offer);
    }

    public changeImageValue(): void {
        this.isAddAction = true;
        setTimeout(() => this.fileUploader.advancedFileInput.nativeElement.click(), 100);
    }

    private displayMessage(severity: string, summary: string, detail: string): void {
        this.messageService.add({
            severity: severity,
            summary: this.localizationService.translate(summary),
            detail: this.localizationService.translate(detail)
        });
    }


    public confirmDeleteOffer(offer: OfferDtoModel) {
        this.confirmationService.confirm({
            message: this.localizationService.translate('OFFERS.DELETE_CONFIRMATION_MESSAGE') + offer.label,
            accept: () => {
                //Actual logic to perform a confirmation
                this.deleteOffer(offer.uuid);
            }
        });
    }

    private deleteOffer(uuid: string): void {
        this.offerService.deleteOffer(uuid).subscribe(
            () => {
                this.loaderService.stopLoading();
                this.displayMessage('success', 'CLIENT.SUCCESS_SUMMARY', 'OFFERS.DELETE_SUCCESS_DETAIL');
                this.getAllOffersByPartner();
            }, (err: any) => {
                console.log(err);
                this.loaderService.stopLoading();
            }
        );
    }

    public sendMail(): void {
        this.offerService.sendMailToAdmin().subscribe(() => {
            this.updateRequestModal = true;
        });
    }
}
